import React from 'react';
import { WarningIcon } from 'assets/icons/WarningIcon';
import { twJoin } from 'tailwind-merge';

const FieldError: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <p
      className={twJoin(
        'text-xs flex gap-0.5 items-center font-semibold text-alert-negative',
        className,
      )}
    >
      <WarningIcon className="w-4 min-w-[1rem] h-4 min-h-[1rem] fill-alert-negative" />
      <span>{children}</span>
    </p>
  );
};

export default FieldError;
